module.exports = __webpack_public_path__ + "media/images/emblems/Sins-blason-a4e9efe3f590eb5f747a323a99b4a3e3.png";